<template>
  <ul class="pagination shadow-sm">
    <div class="pagination-container input-group mr-2" v-if="pageSizes.length > 0">
      <div class="input-group-prepend">
        <label class="input-group-text bg-white border-white pr-2" for="pages">{{name}}</label>
      </div>
      <select class="custom-select border-white" v-model="pageSizeSelect" @change="selectSize" id="pages">
        <option v-for="size in pageSizes" :key="size" :selected="size === pageSizeSelect">{{ size }}</option>
      </select>
    </div>

    <li class="page-item" @click="selectPage(currentPage - 1)" v-show="currentPage !== 1" :class="currentPage === 1 ? 'disabled' : ''">
      <a class="page-link" href="#" aria-label="Previous">
        <i class="far fa-angle-double-left"></i>
      </a>
    </li>

    <li class="page-item" v-for="index in totalPages" :key="index" @click="selectPage(index)" :class="{ active: index === currentPage }" v-show="isVisble(index)">
      <a class="page-link" href="#">{{ index }}</a>
    </li>

    <li class="page-item" @click="selectPage(currentPage + 1)" v-show="currentPage !== totalPages && totalPages > 1" :class="currentPage === totalPages ? 'disabled' : ''">
      <a class="page-link" href="#" aria-label="Next" >
        <i class="far fa-angle-double-right"></i>
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class TopToolBarPaginator extends Vue {
  @Prop({ required: true, default: 0 })
  totalItems: number

  @Prop({ required: true, default: 20 })
  pageSize: number

  @Prop({ required: false, default: false })
  isCursorBased: number

  @Prop({ required: false, default: () => [] })
  pageSizes: number[]

  @Prop({ required: false })
  name: string

  currentPage = 1
  totalPages = 1
  pageSizeSelect: number = NaN

  created () {
    this.pageSizeSelect = this.pageSize
    this.calculatePageNumbers()
  }

  @Watch('totalItems')
  watchTotalItems () {
    this.calculatePageNumbers()
  }

  isVisble (page: number) {
    return page === this.currentPage ||
    (page > 1 && page === this.currentPage - 1) ||
    (page <= this.totalPages && page === this.currentPage + 1) ||
    (page === 1 && this.currentPage === 2) ||
    (!this.isCursorBased && page === 3 && this.currentPage === 1) ||
    (this.currentPage === this.totalPages && this.currentPage - 2 > 0 && page === this.currentPage - 2)
  }

  calculatePageNumbers () {
    this.currentPage = 1
    this.totalPages = Math.ceil(this.totalItems / this.pageSizeSelect)
  }

  selectSize () {
    this.calculatePageNumbers()
    this.$emit('sizeChange', this.pageSizeSelect)
  }

  selectPage (page: number) {
    if (page !== this.currentPage && page > 0 && page <= this.totalPages) {
      this.currentPage = page
      this.$emit('pageChange', page)
    }
  }
}
</script>
